export function toastMsg(position = 'top-end',
                         icon = 'success',
                         title = null,
                         html = null,
                         timer = 3000,
                         showConfirmButton = false,
                         timerProgressBar = true){
      const Toast = Swal.mixin({
            toast: true,
            position: position,
            showConfirmButton: showConfirmButton,
            timer: timer,
            timerProgressBar: timerProgressBar,
            didRender: () => {
                  const swal2Select = document.getElementsByClassName('swal2-select')

                  _.forEach(swal2Select, (item) => {
                        item.classList.add('browser-default');
                        item.classList.add('no-autoinit');
                  })
            }
      })

      Toast.fire({
            icon: icon,
            title: title,
            html: html
      })
}
